// PATH: src/App.jsx
// VERSION: 2.1 — Rutas públicas + /admin (login) y /admin/dashboard protegido
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from './components/AppLayout';
import PushManager from './components/common/PushManager';
import { AudioProvider } from './context/AudioContext';
import GlobalAudioPlayer from './components/common/GlobalAudioPlayer';

// Públicas
import Home from './pages/Home';
import Contact from './pages/Contact';
import SocialMedia from './pages/SocialMedia';
import Encuentranos from './pages/Encuentranos';
import ProximosEventos from './pages/ProximosEventos';
import EstudioBiblico from './pages/EstudioBiblico';
import Donativos from './pages/Donativos';
import Ministerio from './pages/Ministerio';
import FAQ from './pages/FAQ';
import Multimedia from './pages/Multimedia';
import Devocionales from './pages/Devocionales';
import Calendario from './pages/Calendario';
import Albums from './pages/Albums';
import Biblia from './pages/Biblia';
import Enlaces from './pages/Enlaces';
import NuestroHorario from './pages/NuestroHorario';
import Unsubscribe from './pages/Unsubscribe';

// Admin
import Admin from './pages/admin/AdminTabs';
import AdminLogin from './pages/AdminLogin';
import RequireAdmin from './components/Admin/RequireAdmin';

export default function App() {
  return (
    <AudioProvider>
      <GlobalAudioPlayer />
      <AppLayout>
        <PushManager />
        <Routes>
          {/* Públicas */}
          <Route path="/" element={<Home />} />
          <Route path="/contacto" element={<Contact />} />
          <Route path="/encuentranos" element={<Encuentranos />} />
          <Route path="/nuestro-horario" element={<NuestroHorario />} />
          <Route path="/redes-sociales" element={<SocialMedia />} />
          <Route path="/proximos-eventos" element={<ProximosEventos />} />
          <Route path="/estudio-biblico" element={<EstudioBiblico />} />
          <Route path="/multimedia" element={<Multimedia />} />
          <Route path="/biblia" element={<Biblia />} />
          <Route path="/enlaces" element={<Enlaces />} />
          <Route path="/albums" element={<Albums />} />
          <Route path="/ministerio" element={<Ministerio />} />
          <Route path="/calendario" element={<Calendario />} />
          <Route path="/donativos" element={<Donativos />} />
          <Route path="/devocionales" element={<Devocionales />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />

          {/* Admin */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <RequireAdmin>
                <Admin />
              </RequireAdmin>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AppLayout>
    </AudioProvider>
  );
}
